import { render } from "./CriterionStats.vue?vue&type=template&id=5f4e0f8d"
import script from "./CriterionStats.vue?vue&type=script&lang=js"
export * from "./CriterionStats.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__